// extracted by mini-css-extract-plugin
module.exports = {"DescriptionPanel":"DescriptionPanel_DescriptionPanel__k-5-T"};